export enum ProjectViewTabs {
  Sites = "liegenschaften",
  Companies = "unternehmen",
  Generators = "erzeuger",
  Rights = "rechte",
  Settings = "einstellungen",
  Service = "service"
}
